<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="TunnelAttributes"
      :items="TunnelAttributes"
      :fields="TunnelAttributesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedTunnelAttributes"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      TunnelAttributesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'vendor_id', label: this.$i18n.t('Vendor ID'), sortable: true},
        {key: 'attr_type', label: this.$i18n.t('Attribute id'), sortable: true},
        {key: 'data_type_formatted', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTunnelAttributes: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTunnelAttributes = {
        id: 0,
        attr_type: '',
        data_type: 0,
        vendor_id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditTunnelAttributesSettings', '#btnShow')
    },
    editItem (item) {
      this.selectedTunnelAttributes = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditTunnelAttributesSettings', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "ISG attributes"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_TUNNEL_ATTRIBUTES', {id: item.id, attr_type: item.attr_type})
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_TUNNEL_ATTRIBUTES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    TunnelAttributes () {
      let res = []
      this.$store.getters['Settings/TUNNEL_ATTRIBUTES'].forEach(element => {
        if (element.data_type === 0) { element.data_type_formatted = this.$t('INT (3 octets)') }
        if (element.data_type === 1) { element.data_type_formatted = this.$t('STRING') }
        res.push(element)
      })
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TUNNEL_ATTRIBUTES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/TunnelRadiusAttributes/main.vue